<template>
  <div class="cj-select-box" :class="{ inactive: !focused && !value }">
    <span>
      {{ value || placeholder }}
    </span>

    <select :value="value"
            @change="$emit('input', Number($event.currentTarget['value']))"
            @focus="focused = true"
            @blur="focused = false">
      <optgroup :label="placeholder">
        <option v-for="opt in options" :key="opt" :value="opt">
            {{ opt }}
        </option>
      </optgroup>
    </select>
  </div>
</template>

<script>
export default {
  name: 'CJSelectBox',

  data () {
    return {
      focused: false,
    }
  },

  props: {
    value: Number,

    options: {
      type: Array,
      default: () => [ ],
    },

    placeholder: {
      type: String,
    },
  },
}
</script>

<style lang="stylus" scoped>
  .cj-select-box
    position: relative
    display: flex
    justify-content: center
    align-items: center
    color: #1a2787
    text-transform: uppercase
    font-weight: 700
    font-size: 24px
    font-family: 'Futura Std Condensed'

    > span
      margin: 0 7px 4px 0

    > select
      position: absolute
      top: 0
      left: 0
      width: 100%
      min-height: 80%
      height: 100%
      outline: none
      opacity: 0
      cursor: pointer
</style>
